<template>
	<nav class="navbar navbar-expand-lg navbar-light bg-light">
		<router-link class="navbar-brand ms-4" to="/" tag="a">Csoda Admin</router-link>
		<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav3" aria-controls="navbarNav3" aria-expanded="false" aria-label="Toggle navigation" @click="toggledNav = !toggledNav">
			<span class="navbar-toggler-icon"></span>
	  	</button>
		<!--<button class="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbarNav3" aria-controls="navbarNav3" aria-expanded="false" aria-label="Toggle navigation">
			<span class="icon-bar top-bar"></span>
			<span class="icon-bar middle-bar"></span>
			<span class="icon-bar bottom-bar"></span>
		</button>-->
	  	<div class="collapse navbar-collapse" id="navbarNav3" v-bind:class="{ 'show': toggledNav }">
	    	<ul class="navbar-nav mx-auto">
      			<router-link class="nav-item" to="/" tag="li" active-class="active" exact>
	        		<a class="nav-link">Home <span class="sr-only">(current)</span></a>
	      		</router-link>
				<router-link class="nav-item" to="/new-article" tag="li" active-class="active" exact>
	        		<a class="nav-link">New article</a>
	      		</router-link>
	      		<router-link class="nav-item" to="/new-product" tag="li" active-class="active" exact>
	        		<a class="nav-link">New product</a>
	      		</router-link>
	    	</ul>
			<ul class="navbar-nav">
				<li class="nav-item">
	        		<a class="nav-link" @click="signOut">Sign out</a>
	      		</li>
			</ul>
	  	</div>
	</nav>
</template>

<script>

	import firebase from 'firebase';
	
    export default{
    	data (){
    		return {
    			toggledNav: false
    		}
    	},
    	props:{
    		user: Boolean,
    	},
    	methods:{
    		signOut: function(){
	    		firebase.auth().signOut().then(function() {
					self.user = false;
				}).catch(function(error) {
					alert(error);
				});
	    	}
    	},
    	watch: {
    		'$route': function() {
    			console.log(this.toggledNav);
      			this.toggledNav = false

    		}
  		}
    };
</script>


// WEBPACK FOOTER //
// src/components/Navbar.vue